<template>
  <div class="container">
    <div v-for="(item, index) in cardList" :key="index" class="cardlist">
      <div class="action">
        <span class="iconfont icon-complete font-color-red" v-if="item.default==1"></span>
      </div>
      <div class="info">
        <div>姓名:{{item.real_name}}</div>
        <div>身份证号码:{{item.card_id}}</div>
      </div>
      <div class="action" @click="setDefault(item.id)">选择</div>
      <div class="action" @click="delCard(item.id)">删除</div>
    </div>
    <div>
      <div class="showBtn bg-color-red" @click="showAdd">新增身份证信息</div>
    </div>

    <div class="ChangePassword" v-show="show">
      <div class="list">
        <div class="item">
          <input type="text" placeholder="填写真实姓名" v-model="real_name" />
        </div>
        <div class="item">
          <input type="text" placeholder="填写身份证号码" v-model="card_id" />
        </div>
        <div class="default">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" name="default" v-model="is_default" />
                <i class="icon"></i>
                <span class="def">设为默认</span>
              </label>
            </div>
          </div>
        </div>
        <div class="confirmBnt bg-color-red" @click="confirm">保存</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { setDefaultCard, delCard, bindId, getUserCard } from "@api/user";

export default {
  name: "BindingPhone",
  components: {},
  props: {},
  data: function() {
    return {
      real_name: "",
      card_id: "",
      cardList: [],
      is_default: 1,
      show: false
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.getCardList();
  },
  methods: {
    delCard: function(id) {
      var that = this;
      that.$dialog.confirm({
        mes: "确认删除",
        opts: [
          {
            txt: "确认",
            color: false,
            callback: () => {
              delCard({
                id: id
              }).then(res => {
                that.$dialog.toast({ mes: res.msg });
                that.getCardList();
              });
            }
          },
          {
            txt: "取消",
            color: false,
            callback: () => {}
          }
        ]
      });
    },
    setDefault: function(id) {
      var that = this;
      setDefaultCard({ id: id }).then(res => {
        that.$router.go(-1);
      });
    },
    showAdd: function() {
      this.show = !this.show;
    },
    getCardList: function() {
      var that = this;
      getUserCard().then(res => {
        that.cardList = res.data;
        console.log(res.data);
      });
    },
    async confirm() {
      let that = this;
      const { real_name, card_id } = that;

      if (real_name.length < 2) {
        that.$dialog.error("请填写真实姓名");
        return false;
      }
      var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;

      if (!reg.test(card_id)) {
        that.$dialog.error("身份证格式不正确");
        return false;
      }

      bindId({
        real_name: real_name,
        card_id: card_id,
        default: this.is_default
      })
        .then(res => {
          that.$dialog.message(res.msg);
          that.$router.back(-1);
        })
        .catch(res => {
          that.$dialog.toast(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>

<style scoped>
.cardlist {
  display: flex;
  width: 100%;
  padding: 0.3rem;
  justify-content: flex-start;
  border-bottom: 1px #eee solid;
}
.cardlist .info {
  width: 100%;
}
.cardlist .action {
  width: 1rem;
}
.showBtn {
  font-size: 0.32rem;
  width: 5.8rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  color: #fff;
  margin: 0.92rem auto 0 auto;
  text-align: center;
  line-height: 0.9rem;
}
.default {
  padding: 0 0rem;
  height: 0.9rem;
  background-color: #fff;
  margin-top: 0.23rem;
}
.default .def {
  margin-left: 0.6rem;
}
</style>
